import React, { useEffect } from 'react'
import useFetch from '../hooks/useFetch'
import { LinearProgress } from '@mui/material'
import { getMe, verifyGoogleOauth } from '../api-client/data'

const RedirectPage = () => {
    const me = useFetch(getMe)

    const completeRedirect = async () => {
        try {
            const searchParams = window.location.search
            await verifyGoogleOauth(searchParams)

            window.location.href = "/"
        } catch (err) {
            console.error(err)
            window.location.href = "/login"
        }
    }

    useEffect(() => {
        if (me.data?.name !== undefined && me.data?.name?.length > 0) {
            window.location.href = "/"
            return
        }

        if (me.completed) {
            completeRedirect()
        }
    }, [me.completed])

    return (
        <>
            <LinearProgress />
        </>
    )
}

export default RedirectPage